import { render, staticRenderFns } from "./MensagensEnviadas.vue?vue&type=template&id=32646b25&scoped=true&lang=pug&"
import script from "./MensagensEnviadas.vue?vue&type=script&lang=js&"
export * from "./MensagensEnviadas.vue?vue&type=script&lang=js&"
import style0 from "./MensagensEnviadas.vue?vue&type=style&index=0&id=32646b25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32646b25",
  null
  
)

export default component.exports